export default {
  props: {
    doctorId: '',
  },
  data() {
    return {
      tableList: [],
      loading: false,
      currentPage: 1,
      total: 1,
      size: 10,
    };
  },
  methods: {
    /*
     * 获取表格数据
     */
    async getTableList() {
      this.loading = true;
      const params = {
        doctor_id: this.doctorId,
        page_index: this.currentPage,
        page_size: this.size,
      };
      try {
        const res = await this.queryData(params);
        this.tableList = res.data;
        this.total = res.total_num;
      } catch {
        this.$message('获取信息失败');
        this.loading = false;
      }
      this.loading = false;
    },
    /*
     * 切换页码
     */
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableList();
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.size = val;
      this.getTableList();
    },
  },
  created() {
    this.size = this.g_pageSizeDefault;
    this.getTableList();
  },
};
